import { useQuery } from 'react-query';
import { getNutrientDv } from '../api/getNutrientDv';

const useNutrientDv = (options) => {
  // Handle both string (backward compatibility) and object formats
  const queryOptions = typeof options === 'string' ? { shareToken: options } : options;

  const { shareToken, workflowId } = queryOptions || {};

  // Create a unique query key based on the provided parameters
  const queryKey = shareToken ? ['share_token', shareToken] : ['workflow_id', workflowId];

  const result = useQuery(queryKey, () => getNutrientDv(queryOptions), {
    enabled: !!(shareToken || workflowId),
    refetchOnWindowFocus: false,
    staleTime: 3600000,
  });

  return result;
};

export default useNutrientDv;
